import { Component, OnInit } from '@angular/core';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';
import { DialogRef } from 'src/modules/base/components/dialog/dialog-ref';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';

@Component({
    selector: 'app-csvreader',
    templateUrl: './csvreader.component.html',
    styleUrls: ['./csvreader.component.scss'],
    standalone: false
})
export class CSVReaderComponent implements OnInit {
  gridInfo: any = { data: [] };
  gridData: any = { resource: [], count: 0 };
  headers: any = [];
  lines: any;
  constructor(public dialogConfig: DialogConfig, private baseService: BaseService, private loader: LoaderService, private dialogRef: DialogRef,private alerts:AlertsService) { }

  ngOnInit() {
    this.gridInfo.config = {
      print_allowed: false,
      hideSearchBox: true,
      activeField: 'table',
      tile: false,
      table: true,
      allowPagination:true
    }
    this.gridInfo.index = 0;
    this.gridInfo.pageSize = 10;
    console.log(this.dialogConfig, 'this.dialogConfig')
    if (this.dialogConfig.data.fetchFromKeyString == true) {
      let keys = this.dialogConfig.data.resource.split(',')
      let headers = []
      keys.forEach((element, index) => {
        headers.push({
          "card_tag": null,
          "heading": element,
          "name": element,
          "order": index + 1
        })
      });
      this.gridInfo.fields = headers
    }
    else {
      this.baseService.getResourceDef(this.dialogConfig.data.resource, res => {
        this.gridInfo.fields = res.list.fields;
      })
    }
    this.loader.showSpinner()
    var reader = new FileReader()
    reader.readAsText(this.dialogConfig.data.file, "UTF-7");
    reader.onloadend = () => {
      console.log("file---", this.dialogConfig.data.file, reader.result);
      this.setHeaders(reader.result, () => {
        this.initiateGrid(() => {
          this.gridInfo.dataFetched = true
          // this.loader.hideSpinner()
        })
      })
    };
  }
  setHeaders(csvData, callback) {
    if (csvData) {
      csvData = csvData.replace('\r\n','\n')
      // this.lines = csvData.split('\n');
      this.lines = this.CSVToArray(csvData)
      this.headers = (this.lines[0].toString()).split(',')
      this.lines.shift();
      if (this.lines[this.lines.length - 1] === '')
        this.lines.pop();
      callback()
    }
    else
    this.loader.hideSpinner();
  }
  initiateGrid(callback) {
    this.lines.forEach((element, index) => {
      let row = element
      this.gridInfo.data.push({})
      row.forEach((subElem, subIndex) => {
        this.gridInfo.data[index][this.headers[subIndex]] = subElem
      });
    });
    this.updateGridData();
    callback()
    this.loader.hideSpinner()
  }

  confirm(evt) {
    this.dialogRef.close({ confirm: evt })
  }
  appendRecords(evt) {
    this.dialogRef.close({ appendRecords: evt })
  }
  replaceExistingRecords(evt) {
    this.dialogRef.close({ replaceExistingRecords: evt })
  }

  CSVToArray( strData, strDelimiter? ){
    // Check to see if the delimiter is defined. If not,
    // then default to comma.
    strDelimiter = (strDelimiter || ",");
    // Create a regular expression to parse the CSV values.
    var objPattern = new RegExp(
        (
            // Delimiters.
            "(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +
            // Quoted fields.
            "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +
            // Standard fields.
            "([^\"\\" + strDelimiter + "\\r\\n]*))"
        ),
        "gi"
        );
    // Create an array to hold our data. Give the array
    // a default empty first row.
    var arrData = [[]];
    // Create an array to hold our individual pattern
    // matching groups.
    var arrMatches = null;
    // Keep looping over the regular expression matches
    // until we can no longer find a match.
    while (arrMatches = objPattern.exec( strData )){
        // Get the delimiter that was found.
        var strMatchedDelimiter = arrMatches[ 1 ];
        // Check to see if the given delimiter has a length
        // (is not the start of string) and if it matches
        // field delimiter. If id does not, then we know
        // that this delimiter is a row delimiter.
        if (
            strMatchedDelimiter.length &&
            strMatchedDelimiter !== strDelimiter
            ){
            // Since we have reached a new row of data,
            // add an empty row to our data array.
            arrData.push( [] );
        }
        var strMatchedValue;
        // Now that we have our delimiter out of the way,
        // let's check to see which kind of value we
        // captured (quoted or unquoted).
        if (arrMatches[ 2 ]){
            // We found a quoted value. When we capture
            // this value, unescape any double quotes.
            strMatchedValue = arrMatches[ 2 ].replace(
                new RegExp( "\"\"", "g" ),
                "\""
                );

        } else {
            // We found a non-quoted value.
            strMatchedValue = arrMatches[ 3 ];
        }
        // Now that we have our value string, let's add
        // it to the data array.
        arrData[ arrData.length - 1 ].push( strMatchedValue );
    }
    // Return the parsed data.
    return( arrData );
}

pageChanged(event){
console.log(event)
this.gridInfo.index = event-1
this.updateGridData();
}
limitChanged(event){
  this.gridInfo.index=0;
  this.gridInfo.pageSize = event.target.value
  console.log(event)
  this.updateGridData();
}
updateGridData(){
 const pageSize = Number(this.gridInfo.pageSize) || 10;
 const index = Number(this.gridInfo.index) || 0;
 this.gridData = {
  resource: this.gridInfo.data.slice(index * pageSize, index * pageSize + pageSize),
  count: this.gridInfo.data.length
 };
}
}
